// components/EditProfileModal.js
import React, { useState, useRef, useEffect } from 'react';
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { profileService } from '../../../../services/profileService';
import { useTheme } from '../../../../hooks/ThemeProvider';

const EditProfileModal = ({ show, onHide, onSuccess, userProfile,handleWalletDisconnectWithReset }) => {
    const editProfileFileInputRef = useRef(null);
    const [isUpdatingProfile, setIsUpdatingProfile] = useState(false);
    const [profilePreview, setProfilePreview] = useState(null);
const [apiError, setApiError] = useState(null);
    const [editProfileData, setEditProfileData] = useState({
        name: '',
        email: '',
        description: '',
        twitter: '',
        instagram: '',
        discord: '',
        imageUrl: '',
        profileImage: null
    });

      const { theme, toggle } = useTheme();

    const [editProfileErrors, setEditProfileErrors] = useState({});

    // Validation functions
    const validateEmail = (email) => {
        if (!email) return '';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email) ? '' : 'Please enter a valid email address';
    };

    const validateTwitterHandle = (handle) => {
        if (!handle) return '';
        const twitterRegex = /^https:\/\/(www\.)?twitter\.com\/[A-Za-z0-9_]{1,15}$/;
        return twitterRegex.test(handle)
            ? ''
            : 'Please enter a valid Twitter URL (e.g., https://twitter.com/username)';
    };

    const validateInstagramHandle = (handle) => {
        if (!handle) return '';
        const instagramRegex = /^https:\/\/(www\.)?instagram\.com\/[A-Za-z0-9_.]{1,30}$/;
        return instagramRegex.test(handle)
            ? ''
            : 'Please enter a valid Instagram URL (e.g., https://instagram.com/username)';
    };

    const validateDiscordHandle = (handle) => {
        if (!handle) return '';
        // Enforce: 2–32 chars for username, followed by # and exactly 4 digits
        const discordRegex = /^.{2,32}#[0-9]{4}$/;
        return discordRegex.test(handle)
            ? ''
            : 'Please enter a valid Discord handle (e.g., user#1234)';
    };

    const validateForm = () => {
        const errors = {};

        if (!editProfileData.name.trim() && !editProfileData.imageUrl && !editProfileData.profileImage) {
            errors.name = 'Either name or profile image is required';
            errors.profileImage = 'Either name or profile image is required';
        }

        const emailError = validateEmail(editProfileData.email);
        if (emailError) errors.email = emailError;

        const twitterError = validateTwitterHandle(editProfileData.twitter);
        if (twitterError) errors.twitter = twitterError;

        const instagramError = validateInstagramHandle(editProfileData.instagram);
        if (instagramError) errors.instagram = instagramError;

        const discordError = validateDiscordHandle(editProfileData.discord);
        if (discordError) errors.discord = discordError;

        setEditProfileErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // Fetch user profile when modal opens
    useEffect(() => {
        if (show) {
            fetchUserProfile();
        }
    }, [show]);

    const fetchUserProfile = async () => {
        try {
            const profileData = await profileService.fetchProfile();

            if (profileData) {
                setEditProfileData(prev => ({
                    ...prev,
                    name: profileData.name || '',
                    email: profileData.email || '',
                    description: profileData.description || '',
                    imageUrl: profileData.imageUrl || '',
                    twitter: profileData.socialLinks?.twitter || '',
                    instagram: profileData.socialLinks?.instagram || '',
                    discord: profileData.socialLinks?.discord || '',
                }));

                if (profileData.imageUrl) {
                    setProfilePreview(profileData.imageUrl);
                }
            }
        } catch (error) {
            console.log(error, 'ProfileProfileProfileProfile')
            console.error('Failed to fetch profile:', error);
        }
    };

    const handleEditProfileChange = (field, value) => {
        setEditProfileData(prev => ({
            ...prev,
            [field]: value
        }));

        if (editProfileErrors[field]) {
            setEditProfileErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }

        if (field === 'name' && value.trim() && (editProfileErrors.name || editProfileErrors.profileImage)) {
            setEditProfileErrors(prev => ({
                ...prev,
                name: '',
                profileImage: ''
            }));
        }
    };

    const handleEditProfileImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                toast.error('Image size must be less than 5MB');
                return;
            }

            if (!file.type.includes('image/jpeg') && !file.type.includes('image/png')) {
                toast.error('Please select a JPEG or PNG image');
                return;
            }

            setEditProfileData(prev => ({
                ...prev,
                profileImage: file
            }));

            const reader = new FileReader();
            reader.onload = () => {
                setProfilePreview(reader.result);
            };
            reader.readAsDataURL(file);

            if (editProfileErrors.profileImage || editProfileErrors.name) {
                setEditProfileErrors(prev => ({
                    ...prev,
                    profileImage: '',
                    name: ''
                }));
            }
        }
    };

    const handleEditProfileImageButtonClick = () => {
        editProfileFileInputRef.current.click();
    };

    const updateUserProfile = async () => {
        try {
            if (!validateForm()) {
                return;
            }

            setIsUpdatingProfile(true);
            await profileService.updateProfile(editProfileData, editProfileData.profileImage);

            // toast.success('Profile updated successfully');
            onSuccess();
            handleClose();

        } catch (error) {
            console.error('Profile update error:', error);
            toast.error(error.message || 'Failed to update profile');
            // setApiError(error.message || 'Failed to update profile');
            handleClose()
        } finally {
            setIsUpdatingProfile(false);
        }
    };

    const handleClose = () => {
        setEditProfileData({
            name: '',
            email: '',
            description: '',
            twitter: '',
            instagram: '',
            discord: '',
            imageUrl: '',
            profileImage: null
        });
        setProfilePreview(null);
        setEditProfileErrors({});
        onHide();
    };

    return (
        <Modal
            className="stakingmodal"
            show={show}
            onHide={handleClose}
            centered
        >
            <Modal.Header>
                <Modal.Title>
                    <div className="setup_div">
                        <h3>Edit Profile</h3>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="profile_modal">
                    <div className="innter_new">
                        <div className="text_auto">
                            <div className="uploadimg">
                                {profilePreview ? (
                                    <img src={profilePreview} alt="Profile" className="preview-img"  />
                                ) : (
                                    <div>
                                         {
                theme === 'dark' ?   <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
                                        <path d="M20.5833 3.75H5.41667C4.22005 3.75 3.25 4.72005 3.25 5.91667V21.0833C3.25 22.28 4.22005 23.25 5.41667 23.25H20.5833C21.78 23.25 22.75 22.28 22.75 21.0833V5.91667C22.75 4.72005 21.78 3.75 20.5833 3.75Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M9.74967 12.4166C10.9463 12.4166 11.9163 11.4466 11.9163 10.25C11.9163 9.05336 10.9463 8.08331 9.74967 8.08331C8.55306 8.08331 7.58301 9.05336 7.58301 10.25C7.58301 11.4466 8.55306 12.4166 9.74967 12.4166Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M22.75 16.75L19.4068 13.4068C19.0005 13.0006 18.4495 12.7725 17.875 12.7725C17.3005 12.7725 16.7495 13.0006 16.3432 13.4068L6.5 23.25" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg> :
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
  <path d="M20.5833 3.75H5.41667C4.22005 3.75 3.25 4.72005 3.25 5.91667V21.0833C3.25 22.28 4.22005 23.25 5.41667 23.25H20.5833C21.78 23.25 22.75 22.28 22.75 21.0833V5.91667C22.75 4.72005 21.78 3.75 20.5833 3.75Z" stroke="#000F2F" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.75065 12.4166C10.9473 12.4166 11.9173 11.4466 11.9173 10.25C11.9173 9.05336 10.9473 8.08331 9.75065 8.08331C8.55403 8.08331 7.58398 9.05336 7.58398 10.25C7.58398 11.4466 8.55403 12.4166 9.75065 12.4166Z" stroke="#000F2F" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M22.75 16.75L19.4068 13.4068C19.0005 13.0006 18.4495 12.7725 17.875 12.7725C17.3005 12.7725 16.7495 13.0006 16.3432 13.4068L6.5 23.25" stroke="#000F2F" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }

                                        </div>

                                )}
                            </div>

                            <div>
                                <p>Profile Image</p>
                                <span>We recommend to upload images in 500x500 resolution. Max 5 MB in JPEG or PNG.</span>
                                {editProfileErrors.profileImage && (
                                    <div style={{ color: '#ff4757', fontSize: '12px', marginTop: '4px' }}>
                                        {editProfileErrors.profileImage}
                                    </div>
                                )}
                            </div>
                        </div>

                        <input
                            type="file"
                            accept="image/jpeg, image/png"
                            style={{ display: "none" }}
                            ref={editProfileFileInputRef}
                            onChange={handleEditProfileImageChange}
                        />

                        <button onClick={handleEditProfileImageButtonClick}>Upload</button>
                    </div>

                    <div className="input_typpe">
                        <p>Your Name</p>
                        <input
                            placeholder="Enter your full name"
                            type="text"
                            value={editProfileData.name}
                            onChange={(e) => handleEditProfileChange('name', e.target.value)}
                        />

                    </div>
                    {editProfileErrors.name && (
                        <div style={{ color: '#ff4757', fontSize: '12px', marginTop: '4px' }}>
                            {editProfileErrors.name}
                        </div>
                    )}
                    <div className="input_typpe ">
                        <p>Email Address</p>
                        <input
                            placeholder="Enter your email address"
                            type="email"
                            value={editProfileData.email}
                            onChange={(e) => handleEditProfileChange('email', e.target.value)}
                        />

                    </div>
                    {editProfileErrors.email && (
                        <div style={{ color: '#ff4757', fontSize: '12px', marginTop: '4px' }}>
                            {editProfileErrors.email}
                        </div>
                    )}
                    <div className="input_typpe last_inpuut">
                        <p>Bio</p>
                        <input
                            placeholder="Tell about yourself in a few words"
                            type="text"
                            value={editProfileData.description}
                            onChange={(e) => handleEditProfileChange('description', e.target.value)}
                        />
                    </div>

                    <h6>Socials <span> (Optional)</span></h6>

                    <div className="input_typpe">
                        <p>Twitter/X Handle</p>
                        <input
                            placeholder="Enter Twitter Handle"
                            type="text"
                            value={editProfileData.twitter}
                            onChange={(e) => handleEditProfileChange('twitter', e.target.value)}
                        />

                    </div>
                    {editProfileErrors.twitter && (
                        <div style={{ color: '#ff4757', fontSize: '12px', marginTop: '4px' }}>
                            {editProfileErrors.twitter}
                        </div>
                    )}
                    <div className="input_typpe">
                        <p>Instagram Handle</p>
                        <input
                            placeholder="Enter Instagram Handle"
                            type="text"
                            value={editProfileData.instagram}
                            onChange={(e) => handleEditProfileChange('instagram', e.target.value)}
                        />

                    </div>
                    {editProfileErrors.instagram && (
                        <div style={{ color: '#ff4757', fontSize: '12px', marginTop: '4px' }}>
                            {editProfileErrors.instagram}
                        </div>
                    )}
                    <div className="input_typpe">
                        <p>Discord Handle</p>
                        <input
                            placeholder="Enter Discord Handle"
                            type="text"
                            value={editProfileData.discord}
                            onChange={(e) => handleEditProfileChange('discord', e.target.value)}
                        />

                    </div>
                    {editProfileErrors.discord && (
                        <div style={{ color: '#ff4757', fontSize: '12px', marginTop: '4px' }}>
                            {editProfileErrors.discord}
                        </div>
                    )}
                    {apiError && (
                        <div style={{ color: '#ff4757', fontSize: '12px', marginTop: '4px' }}>
                            {apiError}
                        </div>
                    )}
                </div>
                <div className="buton_modal_div">
                    <button
                        onClick={updateUserProfile}
                        disabled={isUpdatingProfile}
                    >
                        {isUpdatingProfile ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default EditProfileModal;